/** 中文翻译表 */
import { aiVideoZh } from './aiVideo'
import { domesticZh } from './domestic'
import { publishCenterZh } from './publishCenter'
import { contentAiZh } from './contentAi'
export const zhCN: Record<string, string> = {
  ...aiVideoZh,
  ...domesticZh,
  ...publishCenterZh,
  ...contentAiZh,
  'nav.back_to_list': '返回列表',
  'shared.ready': '云端共享执行服务已就绪，无需安装 Agent 或配置 API Key。',
  'shared.unavailable': '云端执行服务暂不可用，请稍后重试或联系平台管理员，无需自行安装 Agent。',
  'shared.policy': '任务将公平排队，手动浏览器会话在 {minutes} 分钟后自动关闭。云端执行暂不提供交互式远程桌面。',
  'shared.queued': '请求已进入云端队列，完成后页面将自动更新。',
  'shared.queue_full': '云端待执行任务已达上限，请等待现有任务完成后重试。',
  'shared.expiring': '共享浏览器会话将在一分钟内自动关闭，请及时保存操作。',
  // Settings 页面
  'settings.title': '系统设置',
  'settings.desc': '管理企业信息与团队成员',
  'settings.basic': '基本设置',
  'settings.team': '团队管理',
  'settings.company': '企业信息',
  'settings.company_name': '企业名称',
  'settings.company_name_hint': '企业名称将显示在通知和导出文件中',
  'settings.company_name_placeholder': '请输入企业名称',
  'settings.logo': '企业Logo',
  'settings.logo_hint': '支持 PNG/JPG/SVG/WebP，建议尺寸 200x200，最大 2MB',
  'settings.logo_change': '更换Logo',
  'settings.timezone': '时区',
  'settings.timezone_hint': '影响调度任务执行时间和日志显示',
  'settings.language': '语言',
  'settings.notification': '通知设置',
  'settings.notification_methods': '通知方式',
  'settings.notification_hint': '选择接收系统通知的方式（发布成功/失败、风控告警等）',
  'settings.notification_email': '邮件通知',
  'settings.notification_feishu': '飞书通知',
  'settings.notification_sms': '短信通知',
  'settings.security': '安全设置',
  'settings.security_options': '安全策略',
  'settings.security_hint': '两步验证要求登录时输入验证码；IP白名单限制可访问的IP范围',
  'settings.security_2fa': '两步验证',
  'settings.security_ip': 'IP白名单',
  'settings.security_login_alert': '登录通知',
  'settings.save': '保存设置',
  'settings.reset': '重置',
  'settings.save_success': '保存成功',
  'settings.save_failed': '保存失败',
  'settings.load_failed': '加载设置失败',
  'settings.logo_success': 'Logo 上传成功',
  'settings.logo_failed': 'Logo 上传失败',
  'settings.hero_status': '企业信息自动保存 · 通知与安全独立保存',
  'settings.member_count': '{count} 位团队成员',
  'settings.company_desc': '管理企业品牌和全企业共享的时区；个人语言请在个人中心设置。',
  'settings.auto_save': '自动保存',
  'settings.company_load_error': '企业信息加载失败，暂时无法修改。',
  'settings.retry_load': '重试加载',
  'settings.logo_alt': '企业 Logo',
  'settings.logo_uploading': '上传并保存中…',
  'settings.logo_upload_hint': '点击更换，上传后保存',
  'settings.saving': '正在保存…',
  'settings.name_unsaved': '尚未保存 · 移开焦点或按回车保存',
  'settings.name_saved': '已保存 · 修改后移开焦点或按回车保存',
  'settings.loading': '正在加载…',
  'settings.retry_save': '重试保存',
  'settings.company_display_hint': '企业名称用于侧边栏与页眉展示；未上传 Logo 时，显示名称首字。',
  'settings.timezone_utc': '协调世界时',
  'settings.timezone_shanghai': '上海',
  'settings.timezone_tokyo': '东京',
  'settings.timezone_singapore': '新加坡',
  'settings.timezone_kolkata': '加尔各答',
  'settings.timezone_dubai': '迪拜',
  'settings.timezone_london': '伦敦',
  'settings.timezone_berlin': '柏林',
  'settings.timezone_new_york': '纽约',
  'settings.timezone_chicago': '芝加哥',
  'settings.timezone_los_angeles': '洛杉矶',
  'settings.timezone_sydney': '悉尼',
  'settings.timezone_auto_save': '切换后自动保存，更新后台时间显示',
  'settings.timezone_offset_hint': '对本企业所有成员生效。UTC 偏移按当前日期计算，夏令时地区会自动变化。',
  'profile.language_title': '个人语言设置',
  'profile.language_hint': '切换后自动保存，仅对当前用户生效，不影响企业其他成员。',
  'settings.language_zh': '简体中文',
  'settings.language_auto_save': '切换后自动保存，更新界面语言',
  'settings.name_invalid': '企业名称需为1–100个字符，当前修改尚未保存',
  'settings.save_preserved': '保存失败，已保留输入，请重试',
  'settings.save_restored': '保存失败，已恢复原设置，请重新选择',
  // 团队管理
  'team.title': '团队成员',
  'team.invite': '邀请成员',
  'team.col_user': '成员',
  'team.col_role': '角色',
  'team.col_status': '状态',
  'team.col_last_login': '最后登录',
  'team.col_action': '操作',
  'team.status_active': '正常',
  'team.status_disabled': '已禁用',
  'team.remove': '移除',
  'team.remove_success': '成员已移除',
  'team.invite_title': '邀请成员',
  'team.invite_email': '邮箱地址',
  'team.invite_email_placeholder': '请输入被邀请人邮箱',
  'team.invite_role': '角色',
  'team.invite_role_placeholder': '选择角色',
  'team.invite_cancel': '取消',
  'team.invite_send': '发送邀请',
  'team.invite_success': '邀请已发送',
  'team.invite_email_required': '请输入邮箱',
  'team.desc': '管理成员角色、状态与访问权限',
  'team.seats_title': '团队成员席位',
  'team.seats_desc': 'Owner 免费且不占席位；待激活邀请和已激活成员都会占用席位。',
  'team.seats_purchased': '已购买',
  'team.seats_occupied': '已占用',
  'team.seats_remaining': '剩余',
  'team.seats_unit': '/席位/{months}个月',
  'team.seats_valid_until': '有效期至 {time}',
  'team.seats_standalone': '独立购买，不随套餐赠送',
  'team.seats_unavailable_desc': '商品已下架，已有席位不受影响',
  'team.seats_unavailable': '商品已下架',
  'team.seats_buy': '购买席位',
  'team.seats_view': '查看席位',
  'team.seats_overage': '当前有 {count} 个成员超出有效席位；已有成员会保留，新邀请将被暂停，请续购席位。',
  'team.owner_exempt': 'Owner · 免席位',
  'team.status_invited': '待激活',
  'team.col_mfa': '两步验证',
  'team.mfa_enabled': '已启用',
  'team.mfa_disabled': '未启用',
  'team.never_logged_in': '尚未登录',
  'team.resend_invite': '重发邀请',
  'team.revoke_invite': '撤销邀请',
  'team.edit': '编辑',
  'team.recover_mfa': '恢复两步验证',
  'team.edit_title': '编辑成员',
  'team.nickname': '昵称',
  'team.nickname_placeholder': '请输入昵称',
  'team.status': '状态',
  'team.enable': '启用',
  'team.disable': '禁用',
  'team.invite_intro': '邀请成员加入当前团队',
  'team.invite_intro_desc': '邀请发出后，成员将通过邮件完成账号激活，并自动获得所选角色权限。',
  'team.invite_nickname': '成员昵称',
  'team.invite_nickname_placeholder': '请输入成员昵称',
  'team.load_failed': '团队成员加载失败',
  'team.no_seats': '当前没有可用团队席位，请先购买席位',
  'team.no_seat_permission': '当前角色没有团队席位页面权限，请联系租户 Owner 购买席位',
  'team.product_unavailable': '团队席位商品已下架，已有席位仍可正常使用',
  'team.revoke_title': '确认撤销邀请？',
  'team.remove_title': '确认移除成员「{name}」？',
  'team.revoke_desc': '撤销后原邀请链接将立即失效。',
  'team.remove_desc': '成员账号将被禁用，已签发的刷新凭据会被撤销。',
  'team.remove_confirm': '确认移除',
  'team.revoke_success': '邀请已撤销',
  'team.resend_success': '邀请邮件已重新发送，原邀请链接已失效',
  'team.nickname_required': '请输入成员昵称',
  'team.role_required': '请选择成员角色',
  'team.mfa_recovery_title': '协助 {name} 恢复两步验证？',
  'team.mfa_recovery_desc': '确认后将向该成员的已验证邮箱发送30分钟有效的恢复链接。管理员不能查看或直接关闭成员的验证器。',
  'team.mfa_recovery_send': '发送恢复邮件',
  'team.mfa_recovery_success': '恢复邮件已发送',
  'role.owner': '超级管理员',
  'role.operations': '运营管理',
  'role.content_editor': '内容编辑',
  'role.readonly': '只读查看',
  // 通知设置
  'notification.title': '通知设置',
  'notification.desc': '把发布、风控、导出等业务进展，通知给你选定的企业成员。',
  'notification.scope_what': '关注什么',
  'notification.scope_what_value': '业务任务与结果',
  'notification.scope_who': '发送给谁',
  'notification.scope_who_value': '选定且有权限的成员',
  'notification.scope_when': '何时生效',
  'notification.scope_when_value': '点击底部按钮保存后',
  'notification.load_failed': '通知设置加载失败，不能保存，请重新加载。',
  'notification.channels': '业务通知方式',
  'notification.email': '业务邮件通知',
  'notification.sms_later': '短信通知（后续开放）',
  'notification.channel_hint': '此开关不控制登录安全提醒。验证码、密码重置和邀请邮件也不受影响；站内通知始终保留。',
  'notification.recipients': '邮件接收成员',
  'notification.recipients_placeholder': '选择邮箱已验证的企业成员',
  'notification.recipients_hint': '仅发送成员有权限查看的消息；导出结果和养号任务创建提醒仅发送给被选中的任务发起人。',
  'notification.events': '接收消息类型',
  'notification.events_hint': '发布结果包含成功、失败和待确认；风险告警由现有风控规则产生，遵守套餐权限。',
  'notification.service_unavailable': '平台邮件服务尚未配置，请联系平台管理员。',
  'notification.rules': '发送规则与限制',
  'notification.rules_desc': '变更后只发送新消息，未发送的旧订阅任务将取消；已在途邮件可能已发出。业务邮件每企业每日最多 {limit} 次发送尝试，失败最多重试两次，超额暂缓，超过24小时不再补发。',
  'notification.test_rules': '测试邮件仅发给当前登录者，不会启用业务订阅或登录提醒。每分钟一次、每位管理员24小时最多五次。',
  'notification.delivery_history': '邮件发送记录 · 含业务与登录提醒（保留90天）',
  'notification.refresh': '刷新记录',
  'notification.smtp_hint': '“邮件服务已接收”表示 SMTP 已接收，不代表已进入收件箱；未收到时请检查垃圾邮件。',
  'notification.empty': '暂无发送记录。保存订阅并产生业务事件，或发送测试邮件后可在这里查看。',
  'notification.not_loaded': '设置尚未加载',
  'notification.unsaved': '有未保存的更改，仅影响业务通知',
  'notification.synced': '业务通知设置已同步',
  'notification.reload': '重新加载',
  'notification.cooldown': '测试冷却中（1分钟）',
  'notification.send_test': '发送测试邮件给我',
  'notification.save': '保存通知设置',
  'notification.state_loading': '加载中',
  'notification.state_disabled': '未启用',
  'notification.state_enabled': '已启用',
  'notification.state_unavailable': '邮件服务未配置',
  'notification.state_error': '发送异常',
  'notification.state_unknown': '待确认',
  'notification.col_event': '消息类型',
  'notification.col_recipient': '接收成员',
  'notification.col_status': '发送状态',
  'notification.col_attempts': '尝试次数',
  'notification.col_created': '创建时间',
  'notification.recipient_removed': '已移除成员',
  'notification.selection_required': '请选择接收成员和消息类型',
  'notification.save_success': '通知设置已保存',
  'notification.test_queued': '测试邮件已排队，请稍后刷新发送记录',
  'notification.event.publish': '发布结果',
  'notification.event.alert': '风控告警',
  'notification.event.export': '导出结果',
  'notification.event.team': '团队变更',
  'notification.event.nurture': '养号任务',
  'notification.event.billing': '账单提醒',
  'notification.event.login_security': '登录安全提醒',
  'notification.event.test': '通道测试',
  'notification.status.pending': '等待发送',
  'notification.status.sending': '发送中',
  'notification.status.sent': '邮件服务已接收',
  'notification.status.retry': '等待重试',
  'notification.status.failed': '发送失败',
  'notification.status.cancelled': '已取消',
  'notification.status.expired': '已过期',
  'notification.status.unknown': '发送结果未确认',
  // 安全设置
  'security.title': '安全设置',
  'security.desc': '关注 TikFlow 后台账号的登录安全，提醒直接发送给账号本人。',
  'security.scope_alert': '登录提醒',
  'security.scope_alert_value': '发送给登录账号本人',
  'security.scope_mfa': '两步验证',
  'security.scope_mfa_value': '每位成员自行绑定',
  'security.scope_policy': '企业策略',
  'security.scope_policy_value': '超级管理员统一要求',
  'security.scope_ip': 'IP 白名单',
  'security.scope_ip_value': '仅限指定网络访问',
  'security.load_failed': '安全设置加载失败，请重新加载后再保存。',
  'security.login_email': 'TikFlow 登录邮件提醒',
  'security.login_enable': '启用企业成员登录提醒',
  'security.login_hint_1': '邮箱密码／Google 登录出现新环境，或连续密码错误导致临时锁定时，发送至本人已验证的邮箱；所有套餐可用。',
  'security.login_hint_2': '不使用业务通知的接收成员名单，也不受其开关影响。此处不是 TikTok 环境登录日志，只提醒，不新增登录拦截。',
  'security.service_unavailable': '邮件服务未配置，请联系平台管理员。已启用的策略仍可关闭。',
  'security.mfa_policy': '企业两步验证策略',
  'security.mfa_force': '强制所有企业成员启用验证器',
  'security.mfa_required': '企业已强制启用两步验证',
  'security.mfa_optional': '企业允许成员自行选择是否启用',
  'security.mfa_grace': '开启后，现有成员有 {days} 天完成绑定；策略启用后新增的成员首次登录必须绑定。所有套餐可用。',
  'security.mfa_progress': '已完成 {enabled} / {total} 名启用成员。验证器和恢复码由成员在“个人中心”自行管理，管理员无法查看密钥或恢复码。',
  'security.mfa_bind_first': '请先在个人中心绑定验证器并保存恢复码，才能开启企业强制策略。',
  'security.ip_policy': '企业后台 IP 白名单',
  'security.ip_enable': '仅允许白名单网络访问 TikFlow 用户后台',
  'security.enabled': '已启用',
  'security.disabled': '未启用',
  'security.ip_hint': '仅 Business、Enterprise 可配置；不影响 Agent、TikTok 浏览器代理或第三方回调。',
  'security.current_ip': '当前真实访问 IP：',
  'security.ip_unknown': '无法识别',
  'security.ip_upgrade': '当前套餐不支持企业后台 IP 白名单，请升级至 Business 或 Enterprise。',
  'security.ip_save_warning': '保存时后端会确认当前真实 IP 仍在允许范围内，否则拒绝变更。',
  'security.ip_name_placeholder': '名称，如广州办公室',
  'security.ip_cidr_placeholder': 'IP 或 CIDR',
  'security.delete': '删除',
  'security.add_address': '添加地址',
  'security.add_current_ip': '添加当前 IP',
  'security.rules': '登录提醒规则与限制',
  'security.rules_desc_1': '首次记录登录环境、近30天未记录的 IP／浏览器系统组合及临时锁定时提醒；最多记忆20组组合。不是精准设备识别或异地定位，网络或代理切换也可能触发，不表示账号被盗。',
  'security.rules_desc_2': '重复退出登录、刷新页面、令牌续期不会重复提醒。每位成员10分钟最多一封、24小时最多五封，平台另设总量限制。超过1小时不再发送，超额不补发旧提醒。',
  'security.rules_desc_3': '默认关闭；修改后取消未发送的旧队列，已在途邮件可能已发出。发送状态统一显示在“通知设置”的邮件发送记录中。',
  'security.not_loaded': '设置尚未加载',
  'security.unsaved': '有未保存的安全策略更改',
  'security.synced': '登录安全设置已同步',
  'security.reload': '重新加载',
  'security.save': '保存安全设置',
  'security.state_loading': '加载中',
  'security.state_disabled': '登录提醒未启用',
  'security.state_enabled': '登录提醒已启用',
  'security.state_unavailable': '邮件服务未配置',
  'security.state_error': '加载失败',
  'security.state_unknown': '待确认',
  'security.save_success': '安全设置已保存',
  'security.current_network': '当前网络',
  // 用户后台导航与标题
  'nav.upgrade': '升级套餐',
  'nav.unlock_all': '解锁全部功能',
  'nav.price_from': '从¥999/月起',
  'nav.company_settings': '进入企业设置',
  'nav.current_company': '当前企业',
  'nav.plan_center': '套餐中心',
  'nav.notification_center': '通知中心',
  'nav.unread': '通知中心 · {count} 条未读',
  'nav.mfa_grace': '企业已要求启用两步验证，请在 {deadline} 前完成绑定。',
  'nav.bind_now': '立即绑定',
  'nav.deadline_unknown': '规定时间',
  'nav.group.home': '工作台',
  'nav.group.accounts': '账号管理',
  'nav.group.nurture': '养号中心',
  'nav.group.assets': '内容素材',
  'nav.group.publish': '发布中心',
  'nav.group.risk': '风控安全',
  'nav.group.system': '系统管理',
  'nav.group.billing': '计费中心',
  'nav.group.profile': '个人中心',
  'route.Login': '登录',
  'route.Logout': '退出登录',
  'route.Dashboard': '工作台首页',
  'route.Accounts': '环境管理',
  'route.BindAccount': '批量导入环境',
  'route.BatchImport': '批量导入环境',
  'route.GroupManage': '环境分组管理',
  'route.ProxyManage': '代理管理',
  'route.HealthAnalysis': '账号健康分析',
  'route.AccountDetail': '环境详情',
  'route.NurtureStrategies': '养号策略列表',
  'route.StrategyConfig': '策略配置',
  'route.StrategyEdit': '编辑策略',
  'route.NurtureMonitor': '养号监控',
  'route.ExecConsole': '养号执行控制台',
  'route.ExecConsoleDetail': '养号执行控制台',
  'route.NurtureAnalytics': '养号效果分析',
  'route.NurtureHealth': '账号健康分析',
  'route.Assets': '素材库管理',
  'route.PublishTasks': '发布任务',
  'route.PublishCreate': '新建发布',
  'route.PublishResults': '发布记录',
  'route.PublishSchedule': '智能排程',
  'route.PublishCalendar': '发布日历',
  'route.RiskCenter': '风险告警',
  'route.RiskIntel': '情报库',
  'route.BanRate': '封禁率统计',
  'route.AuditLogs': '审计日志',
  'route.LoginLogs': '登录日志',
  'route.BillingPlans': '套餐中心',
  'route.BillingTeamSeats': '团队席位',
  'route.BillingUsage': '资源使用情况',
  'route.BillingInvoices': '历史账单',
  'route.Roles': '角色权限管理',
  'route.Settings': '系统设置',
  'route.DataExport': '数据导出',
  'route.SystemAuditLogs': '审计日志',
  'route.Notifications': '通知中心',
  'route.Profile': '个人中心',
  'route.AccessDenied': '无权访问',
  'route.Prototype': '原型预览',
  'guard.mfa_required': '企业要求启用两步验证，请先完成绑定',
  'guard.permission_denied': '当前角色没有访问该页面的权限',
  'guard.entitlements_failed': '套餐权益加载失败，请稍后重试',
  'guard.feature_unavailable': '当前套餐未开放此功能，请升级套餐',
  'request.environment_quota_full': '环境额度已满',
  'request.plan_unsupported': '当前套餐暂不支持此操作',
  'request.quota_detail': '（已使用 {used}/{limit}）',
  'request.view_plans': '查看套餐',
  'request.later': '稍后再说',
  'request.plan_restricted': '当前套餐受限',
  'request.failed': '请求失败',
  'request.network_denied': '当前网络不在企业允许范围',
  'request.network_error': '网络异常',
  'request.mfa_required': '请先完成两步验证绑定',
  'request.agent_required_title': '需要先部署并启动 TikFlow Agent',
  'request.agent_required_intro': '当前操作必须由在线的 Agent 节点执行，请按以下步骤检查：',
  'request.agent_required_step_installed': '已经安装：启动 TikFlowAgent Windows 服务，并确认 AdsPower 正在运行且 Local API 已启用。',
  'request.agent_required_step_new': '尚未安装：向管理员获取 Windows 安装包，再点击“前往部署 Agent”生成一次性注册码；没有部署权限时请联系管理员。',
  'request.agent_required_step_retry': '安装完成后等待节点显示在线，再返回当前页面重新添加代理。',
  'request.deploy_agent': '前往部署 Agent',
  'reauth.title': '确认当前账号身份',
  'reauth.confirm': '确认并继续',
  'reauth.password': '当前企业登录密码',
  'reauth.email_code': '登录邮箱验证码',
  'reauth.code_placeholder': '六位验证码',
  'reauth.resend': '重新发送',
  'reauth.send': '发送验证码',
  'reauth.mfa_code': '验证器验证码或恢复码',
  'reauth.hint': '验证结果仅用于本次操作，5分钟后自动失效。',
  'reauth.action.tenant_security': '你正在修改企业登录安全策略。',
  'reauth.action.ip_allowlist': '你正在修改企业后台允许访问的网络。',
  'reauth.action.account_password': '你正在修改账号登录密码，完成后所有旧会话将退出。',
  'reauth.action.account_mfa': '你正在修改账号的两步验证方式。',
  'reauth.action.role_access': '你正在修改角色及其权限。',
  'reauth.action.member_access': '你正在修改企业成员访问权限。',
  'reauth.action.agent_credential': '你正在生成或吊销 Agent 节点凭据。',
  'reauth.action.mfa_recovery': '你正在为企业成员发起两步验证恢复。',
  'reauth.action.default': '你正在执行高风险操作。',
  'reauth.replaced': '已有新的重新验证请求',
  'reauth.cancelled': '已取消重新验证',
  'reauth.not_ready': '重新验证组件尚未就绪',
  // 通用
  'common.save': '保存',
  'common.cancel': '取消',
  'common.saved': '保存成功',
}
